export const extractFileExtension = (url: string): string =>
  url.split("?")?.[0]?.split(".")?.pop()?.toLowerCase() ?? "";

export function downloadFile(
  data: string,
  fileName: string,
  mimeType: string,
  charset = "utf-8",
) {
  const anchor = document.createElement("a");
  const href = `data:${mimeType};charset=${charset},${encodeURI(data)}`;
  anchor.href = href;
  anchor.setAttribute("download", fileName);
  anchor.setAttribute("target", "_blank");
  anchor.click();
}

export async function downloadFileFromUrl(
  url: string,
  fileName: string,
): Promise<void> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to download file: ${response.statusText}`);
  }
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    if (document.body.contains(anchor)) {
      document.body.removeChild(anchor);
    }
    URL.revokeObjectURL(blobUrl);
  }
}
